module.exports = __webpack_public_path__ + "img/about-story.94c09f86.jpg";